import { baseAPI } from '~/shared/api/base-api';
import type {
  RecitalCheckIn,
  CreateCheckInDto,
  CheckInStats,
  CheckInQueryParams,
} from '../model/types/volunteers';

export const checkInsApi = {
  // Check in student or volunteer
  create: async (
    recitalId: string,
    data: CreateCheckInDto
  ): Promise<RecitalCheckIn> => {
    const response = await baseAPI.post(
      `/recitals/${recitalId}/check-in`,
      data
    );
    return response.data;
  },

  // Check out student or volunteer
  checkOut: async (
    recitalId: string,
    data: CreateCheckInDto
  ): Promise<RecitalCheckIn> => {
    const response = await baseAPI.post(
      `/recitals/${recitalId}/check-out`,
      data
    );
    return response.data;
  },

  // List all check-ins for a recital
  list: async (
    recitalId: string,
    params?: CheckInQueryParams
  ): Promise<RecitalCheckIn[]> => {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/check-ins`,
      { params }
    );
    return response.data;
  },

  // Toggle check-in functionality for recital
  toggleCheckIn: async (
    recitalId: string,
    enabled: boolean
  ): Promise<{ message: string; recital: any }> => {
    const response = await baseAPI.patch(
      `/recitals/${recitalId}/toggle-check-in`,
      { enabled }
    );
    return response.data;
  },

  // Get check-in statistics
  getStats: async (recitalId: string, showId?: string): Promise<CheckInStats> => {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/check-in-stats`,
      { params: showId ? { showId } : undefined }
    );
    return response.data;
  },

  // Get students available for check-in
  getStudentsAvailableForCheckIn: async (
    recitalId: string,
    showId?: string
  ): Promise<Array<{
    studentId: string;
    firstName: string;
    lastName: string;
    name?: string;
    performances: Array<{
      performanceId: string;
      performanceName: string;
      showId: string;
      showName: string;
      showDate: string;
    }>;
    isCheckedIn: boolean;
    checkedInAt?: string;
    canCheckOut: boolean;
  }>> => {
    const response = await baseAPI.get(
      `/recitals/${recitalId}/students-available-for-checkin`,
      { params: showId ? { showId } : undefined }
    );
    return response.data;
  },
};
